<template>

    <div class="row">
        <div v-for="status in statuses" class="col-sm-2">
            <div class="box box-solid">
                <div class="box-header">
                    <h2 class="box-title">{{ status.name }}</h2>
                </div>
                <div
                    :class="{'box-body':true, 'ni-group-wrapper':projects[status.id].length === 0}"
                >
                    <div class="no-items-group"
                        v-if="projects[status.id].length === 0"
                    >
                        <span>Geen projecten gevonden<br /><br />Sleep projecten hierin om <br />ze deze status te geven</span>
                    </div>
                    <draggable
                        :class="{'list-group':true, 'ni-group':projects[status.id].length === 0}"
                        :list="projects[status.id]"
                        group="projects"
                        @change="changeHandler($event, status.id)"
                    >
                        <div class="list-group-item"
                            v-for="project in projects[status.id]"
                            :key="project.uuid"
                        >
                            <router-link
                                :to="{name:'projects.details.index', params:{uuid:project.uuid}}"
                                class="btn btn-xs btn-primary pull-right"
                                v-tooltip="'Project openen'"
                            >
                                <i class="mdi mdi-eye"></i>
                                <span class="sr-only">Project openen</span>
                            </router-link>
                            {{ project.name }}
                        </div>
                    </draggable>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

import axios from 'axios';
import draggable from "vuedraggable";

export default {

    components: {
        draggable,
    },

    computed: {
    },

    data() {
        return {
            projects:[],
            statuses:[],
        }
    },

    methods: {
        getProjects(status_id) {
            return this.projects[parseInt(status_id)];
        },
        getSortingData(){
            axios.get(this.sortUri)
            .then(resp => {
                this.projects = resp.data.projects;
                this.statuses = resp.data.statuses;
            });
        },
        changeHandler(el, status_id) {
            if (el.added) {
                axios.patch(this.updateUri, {
                    project_uuid: el.added.element.uuid,
                    newstatus:status_id,
                }).then();
            }
        }
    },

    mounted() {
        this.getSortingData();
    },

    name:"ProjectSorting",

    props: {
        sortUri: { required:true },
        updateUri: { required:true },
    },

}

</script>

<style lang="scss">

.list-group-item {

    transition:background-color 0.2s ease-in-out;

    &:hover {
        background-color:#efefef;
        cursor:all-scroll;
    }

    &.sortable-ghost {
        background-color:#ccc;
    }

}

.ni-group-wrapper {
    position:relative;

    .no-items-group {
        border-radius:3px;
        border:3px dotted #ccc;
        text-align:center;
        display:table;
        min-height:200px;
        width:100%;

        > span {
            display:table-cell;
            height:100%;
            vertical-align:middle;
            text-align:center;
            font-style:italic;
            font-size:0.9em;
        }
    }

    .ni-group {
        min-height:220px;
        position:absolute;
        left:0;
        top:0;
        width:100%;
        padding:10px;
    }
}

</style>
